module.exports = __webpack_public_path__ + "static/media/tool_logo_tenable.05c390dc.png";